import React from 'react';
import { MapPinIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const Footer = () => {
  const {
    t
  } = useLanguage();
  const whatsappLink = getWhatsAppLink('Hola Pedro, vi tu página web y quiero más información.');
  return <footer className="bg-dark text-white py-8 px-4" data-id="element-34" data-mp="5p6sk5dofn9e">
      <div className="container mx-auto" data-id="element-35" data-mp="o9ea3vsfdd6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-36" data-mp="q2izdmubnij">
          <div data-id="element-37" data-mp="3s1cc9ubvvs8u">
            <h3 className="font-heading font-semibold text-xl mb-2" data-id="element-38" data-mp="3s0kjer9o88m9">
              {t.footer.title}
            </h3>
            <p className="text-gray-400" data-id="element-39" data-mp="3j1z3z4zhx9pp">{t.footer.role}</p>
            <address className="not-italic text-sm space-y-2 mt-3 text-gray-300" data-id="element-40" data-mp="3j3jt2f31k0g6">
              <div className="flex items-center" data-id="element-41" data-mp="3e1ks1burxfme">
                <MapPinIcon className="w-4 h-4 mr-2 text-primary flex-shrink-0" data-id="element-42" data-mp="393syyeie7ngm" />
                21400 NW 2nd Ave, Miami Gardens, FL 33169
              </div>
              <div className="flex items-center" data-id="element-43" data-mp="2kbjtz8zca7gk">
                <PhoneIcon className="w-4 h-4 mr-2 text-primary flex-shrink-0" data-id="element-44" data-mp="2p3l2qkxatg1u" />
                <a href="tel:+18572715381" className="hover:text-white transition-colors" data-id="element-45" data-mp="2p5nxfi9ebxcw">
                  (857) 271-5381
                </a>
              </div>
              <div className="flex items-center" data-id="element-46" data-mp="341dfj5bgnqcc">
                <MailIcon className="w-4 h-4 mr-2 text-primary flex-shrink-0" data-id="element-47" data-mp="341lrmuzrermh" />
                <a href="mailto:info@faranduladelacruz.com" className="hover:text-white transition-colors" data-id="element-48" data-mp="381nsj1xo7h0p">
                  info@faranduladelacruz.com
                </a>
              </div>
            </address>
          </div>
          <div className="flex flex-col items-center md:items-end gap-2" data-id="element-49" data-mp="1inhouwsxi5rh">
            <a href={whatsappLink} className="text-white hover:text-primary transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-50" data-mp="1nmubbgfw1atj">
              WhatsApp: (857) 271-5381
            </a>
            <nav className="flex items-center gap-4 text-sm text-gray-300" data-id="element-51" data-mp="zjnw10s49hy7">
              <a href="/privacy-policy" className="hover:text-white underline underline-offset-4 transition-colors" data-id="element-52" data-mp="ure2larslzr6">
                Política de Privacidad
              </a>
              <span aria-hidden="true" className="text-gray-600" data-id="element-53" data-mp="kvt1rfygn5j0">
                •
              </span>
              <a href="/terms" className="hover:text-white underline underline-offset-4 transition-colors" data-id="element-54" data-mp="ftu1iey0ooqa">
                Términos de Servicio
              </a>
            </nav>
            <p className="text-gray-400 text-sm" data-id="element-55" data-mp="267ks1giay98c">
              © {new Date().getFullYear()} Carros de la Cruz — Pedro de la
              Cruz, Fleet Manager. {t.footer.rights}
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;